/** Canonical sessionStorage keys. One-shot migrate from r1-monitoring-* if present. */
const PREFIX = "r1-horizonscanning-";
const LEGACY_PREFIX = "r1-monitoring-";

function migrateOnce(suffix: string): string | null {
  const next = PREFIX + suffix;
  const current = sessionStorage.getItem(next);
  if (current != null) return current;
  const legacy = sessionStorage.getItem(LEGACY_PREFIX + suffix);
  if (legacy == null) return null;
  sessionStorage.setItem(next, legacy);
  sessionStorage.removeItem(LEGACY_PREFIX + suffix);
  return legacy;
}

export const horizonScanningSession = {
  pending: "pending",
  org: "org",
  session: "session",
  email: "email",
  pendingId: "pending-id",
  wizard: "wizard",
} as const;

export function getHorizonScanningSession(suffix: string): string | null {
  try {
    return migrateOnce(suffix);
  } catch {
    return null;
  }
}

export function setHorizonScanningSession(suffix: string, value: string): void {
  try {
    sessionStorage.setItem(PREFIX + suffix, value);
    sessionStorage.removeItem(LEGACY_PREFIX + suffix);
  } catch {
    /* ignore quota / private mode */
  }
}
